import React, { useState } from "react"
import YouTube from "react-youtube"

import { Cover } from "components/anti/cover/cover"
import { useScrollAnim } from "src/components/hooks/hooks"

import ThumbnailDef from "assets/img/bg_about_thumbnail.jpg"
import PlayBtn from "assets/img/play_btn.png"

export const YoutubeFrame = ({ link, className, thumbnail, isAmp }) => {
    const [trigger, anim] = useScrollAnim()

    const [videoOpts, setVideoOpts] = useState({
        autoPlay: 1,
        controls: 1,
        showBtn: true,
    })

    const videoOptions = {
        playerVars: {
            autoplay: videoOpts.autoPlay,
            controls: videoOpts.controls,
            play: 0,
            hidden: 0,
            playsInline: 0,
            hidden: 0,
            rel: 0,
            showinfo: 0,
            mute: 0,
            modestbranding: 1,
        },
    }

    const [isPlay, setIsPlay] = useState(false)

    const onPlay = () => {
        setIsPlay(!isPlay)
    }

    let re = /^(https?:\/\/)?((www\.)?(youtube(-nocookie)?|youtube.googleapis)\.com.*(v\/|v=|vi=|vi\/|e\/|embed\/|user\/.*\/u\/\d+\/)|youtu\.be\/)([_0-9a-z-]+)/i

    return (
        <>
            <section ref={trigger} className="yt-project-detail">
                {link &&
                    <>
                        {isPlay && !isAmp ?
                            <div className={`px-sm-down-0 ${className}`} >
                                <div className={`embed-responsive embed-responsive-16by9 h-250px h-md-550px `}>
                                    <YouTube
                                        videoId={link.match(re)[7]}
                                        opts={videoOptions}
                                        className={`h-250px h-md-550px`}
                                    />
                                </div>
                            </div>
                            :
                            <div className={`position-relative ${className} ${anim(1)}`}>
                                <Cover
                                    variant="basic"
                                    img={thumbnail?.image ? thumbnail?.image?.sourceUrl : ThumbnailDef}
                                    imgHeight="h-250px h-md-550px"
                                    titleClassName="pt-sm-down-3 w-sm-down-250px align-cover-title"
                                    className="global-cover"
                                >
                                    {(link && link.match(re)?.length) &&
                                        <img src={PlayBtn} alt="" className="play-btn" onClick={onPlay} />
                                    }
                                </Cover>
                            </div>
                        }
                    </>
                }
            </section>
        </>
    )
}